import { CopilotEnvironment, CopilotStarterPrompt } from '@assembly/types'

export const COPILOT_PLATFORM = 'client-dashboard'

export const COPILOT_AUTH_BASE_URL = process.env.REACT_APP_ENV_API_BASE_URL || ''

export const COPILOT_AUTH_ENDPOINTS = {
  verify: '/auth/session/team_member',
  oneTimeCode: '/auth/team_member/one-time-code',
  login: '/auth/team_member/login',
  logout: '/auth/team_member/logout',
} as const

export const COPILOT_THEME = 'light' as const

export const COPILOT_ENVIRONMENT = {
  LOCAL: 'local',
  DEVELOPMENT: 'dev',
  STAGING: 'staging',
  PRODUCTION: 'prod',
} as const

export const COPILOT_ENV: CopilotEnvironment =
  (process.env.REACT_APP_ENV as CopilotEnvironment) || COPILOT_ENVIRONMENT.LOCAL

export const COPILOT_ASSEMBLY_ID = process.env.REACT_APP_CO_PILOT_ASSEMBLY_ID
export const COPILOT_WORKFLOW_ID = process.env.REACT_APP_CO_PILOT_WORKFLOW_ID

export const COPILOT_STARTER_PROMPTS: CopilotStarterPrompt[] = [
  {
    id: 'get-started',
    title: 'Get Started',
    query: 'What can I do here and how can you help me?',
    prompt:
      'Explain to the user what they can do on this dashboard and how you can help them. Keep it concise and actionable.',
  },
  {
    id: 'report-issue',
    title: 'Report Issue',
    query: 'I need to report an issue',
    prompt:
      'The user wants to report an issue. Ask them to describe the problem they are experiencing. Once they have explained their issue, proactively contact customer support on their behalf and let them know their issue has been escalated.',
  },
]
